import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Button, Field } from "../components/ui";
import { confirmReset, verifyReset } from "../lib/reset";

const box = { background: "var(--error)", color: "var(--on-error)", padding: 12, borderRadius: "var(--r-md)", fontSize: 13 };

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [valid, setValid] = useState(null);
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (!token) return setValid(false);
    verifyReset(token).then((r) => setValid(r.valid)).catch(() => setValid(false));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (next.length < 8) return setError("A palavra-passe deve ter pelo menos 8 caracteres.");
    if (next !== confirm) return setError("As palavras-passe não coincidem.");
    setBusy(true);
    try {
      await confirmReset(token, next);
      setDone(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="app-root" style={{ minHeight: "100vh" }}>
      <div className="ulc-fade" style={{ maxWidth: 520, margin: "0 auto", padding: "clamp(48px, 10vh, 120px) 24px 32px", display: "flex", flexDirection: "column", gap: 24 }}>
        <div className="t-kicker">URBAN LISBON CHOIR</div>
        <h1 data-testid="reset-title" style={{ fontFamily: "var(--f-light)", fontWeight: 300, fontSize: 36, margin: 0 }}>Nova palavra-passe</h1>
        {valid === null ? <p style={{ color: "var(--on-surface-3)" }}>A verificar o link…</p> : null}
        {valid === false && !done ? <div data-testid="reset-invalid" style={box}>Este link é inválido ou já expirou. Volte a pedir a recuperação na página de início de sessão.</div> : null}
        {done ? (
          <div data-testid="reset-success" style={{ background: "var(--success)", color: "var(--on-success)", padding: 12, borderRadius: "var(--r-md)", fontSize: 14 }}>
            Palavra-passe alterada. Já pode iniciar sessão na app Web e na app Mobile.
          </div>
        ) : null}
        {valid && !done ? (
          <form onSubmit={submit} style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            <Field label="NOVA PALAVRA-PASSE" type="password" value={next} onChange={(e) => setNext(e.target.value)} placeholder="Mínimo 8 caracteres" autoComplete="new-password" data-testid="reset-password-new" />
            <Field label="CONFIRMAR PALAVRA-PASSE" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} autoComplete="new-password" data-testid="reset-password-confirm" />
            {error ? <div data-testid="reset-error" style={box}>{error}</div> : null}
            <Button type="submit" loading={busy} data-testid="reset-submit">GUARDAR</Button>
          </form>
        ) : null}
        <Link to="/login" data-testid="reset-back-login" style={{ color: "var(--on-surface-3)", textDecoration: "underline", fontSize: 14 }}>Voltar ao início de sessão</Link>
      </div>
    </div>
  );
}
